import $ from 'jquery';
import jQuery from 'jquery';
import utils from './utils';
import Cookies from "js-cookie";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const nav = {
	hamburger: () => {
		let hamburger = document.querySelector('.nav-toggle');
		if (!hamburger)
			return;
		let container = document.querySelector('body');
		hamburger.addEventListener('click', () => {
			hamburger.classList.toggle('nav--toggled')
			container.classList.toggle('nav--toggled')
		})
	},
	base: () => {
		const itemsWithChildren = document.querySelectorAll('li.has-children');
		itemsWithChildren.forEach(item => {
			item.addEventListener('click', (e) => {
				if (e.target.classList.contains('arrow')) {
					e.preventDefault();
				}
			})
		})
	},
	search: () => {
		const searchOpen = document.querySelector('.js-open-search');
		const searchWrapper = document.querySelector('.js-search');
		const searchClose = document.querySelector('.js-search-wrapper-close');

		searchOpen?.addEventListener('click', () => {
			searchWrapper.classList.toggle('open');
		});

		searchClose?.addEventListener('click', () => {
			searchWrapper.classList.remove('open');
		})
	},
	accordion: () => {
		const accordions = $('.js-accordion');
		accordions.each(function () {
			const $this = $(this);
			const accordionButton = $this.find('.js-accordion-title');
			const accordionContents = $this.find('.js-accordion-content');
			accordionContents.slideUp();
			accordionContents.addClass('slide-up');
			if ($this.hasClass('js-accordion-nested-files')) {
				accordionButton.first().addClass('slide-up');
				accordionContents.first().slideDown();
			}
			accordionButton.click(function (e) {
				const accordionContent =
					$(this).closest('.submenu').length ? $(this).parent().next('.js-accordion-content') : $(this).next('.js-accordion-content');

				$(this).toggleClass('slide-up');
				accordionContent.slideToggle();
			});

		})
	},
	stickyHeader: () => {
		const nav = document.querySelector('.header-nav__menu.active');
		const linksSticky = document.querySelectorAll('.js-header-sticky a:not(.js-external)');
		const accordions = document.querySelectorAll('.header-nav .js-accordion-content');
		const close = document.querySelector('.js-close-nav');
		const backBtns = document.querySelectorAll('.js-back-nav');

		if (!nav || !linksSticky || !close) return;

		const links = nav.querySelectorAll('.js-accordion-parent');

		linksSticky?.forEach(link => {
			handleStickyLinkClick(link);
		});

		links?.forEach(link => {
			handleInnerLinkClick(link);
		});

		backBtns?.forEach(btn => {
			btn.addEventListener('click', function (e) {
				resetNavDepth();
			})
		});

		close.addEventListener('click', function (e) {
			e.preventDefault();
			closeNav();
		});

		function resetNavDepth() {
			accordions.forEach(accordion => {
				accordion.style.display = 'none';
				enableBodyScroll(accordion);
			});
			links?.forEach(link => link.parentElement.classList.remove('active'));
		}

		function closeNav() {
			nav.classList.remove('visible');
			close.classList.remove('visible')
			document.body.classList.remove('nav-visible');
			linksSticky.forEach(l => l.classList.remove('active'));
			resetNavDepth();
			clearAllBodyScrollLocks();
		}

		function handleInnerLinkClick(link) {
			const anchor = link.querySelector('a');
			if (!anchor) return;

			anchor.addEventListener('click', function (e) {
				e.preventDefault();
				const accordion = link.nextElementSibling;

				resetNavDepth();

				if (accordion) {
					const children = accordion.querySelector('.submenu__list');

					accordion.style.display = 'block';
					link.parentElement.classList.add('active');

				}
			});
		}

		function handleStickyLinkClick(link) {
			link?.addEventListener('click', function (e) {
				e.preventDefault();

				const hasActive = link.classList.contains('active');

				if (!hasActive) {
					linksSticky.forEach(l => l.classList.remove('active'));
				}
				link.classList.toggle('active', !hasActive);

				handleMenuToggle(link);
				resetNavDepth();
			})
		}

		function handleMenuToggle(link) {
			const container = document.querySelector('.header-nav__menu.active');

			if (!container) return;

			const hasActive = document.querySelector('.js-header-sticky a.active');
			const id = link.getAttribute('data-id');
			const children = nav.querySelectorAll('.header-nav__menu-item');
			const submenu = link.querySelector('.submenu');

			console.log(children);

			nav.classList.toggle('visible', !!hasActive);
			close.classList.toggle('visible', !!hasActive);
			document.body.classList.toggle('nav-visible', !!hasActive);

			clearAllBodyScrollLocks();

			if (hasActive) {
				if (submenu) {
					disableBodyScroll(container);
					disableBodyScroll(submenu);
				}
			} else {
				clearAllBodyScrollLocks();
			}

			children.forEach(child => {
				const matchingId = child.dataset.id === id;
				child.style.setProperty('--visibility', matchingId ? 'visible' : '');
				child.style.setProperty('--opacity', matchingId ? 1 : '');
			});
		}
	},

	refreshFaqAccordion: (loadedCount) => {
		if (loadedCount === 'all') {
			loadedCount = '-1';
		}
		const loadedCountClass = `.paged_${loadedCount}`;
		const accordions = $('.js-accordion.js-loadmore-wrapper');
		accordions.each(function () {
			const $this = $(this);
			const accordionButton = $this.find(` ${loadedCountClass} .js-accordion-title`);
			accordionButton.unbind('click');
			accordionButton.click(function () {
				const accordionContent = $(this).next(` ${loadedCountClass} .js-accordion-content`);
				$(this).toggleClass('slide-up');
				accordionContent.slideToggle();
			});
		})
	},
	scrollToId: () => {
		$('a[href*="#"][class="js-scroll-to-id-link"]').on('click', function (e) {
			e.preventDefault()
			$('html, body').animate({
				scrollTop: $($(this).attr('href')).offset().top - 30,
			},
				500,
				'linear'
			)
		})
	},
	scrollTop: () => {
		const scrollTopButton = $('.js-scroll-top');
		if (scrollTopButton.length > 0) {
			var $window = $(window);
			var breakpoint = 'desktop';

			function checkWidth() {
				var windowsize = $window.width();
				if (windowsize < 1024) {
					breakpoint = 'mobile'
				} else {
					breakpoint = 'desktop'
				}
			}
			checkWidth();
			$(window).resize(checkWidth);
			// Animate the scroll to top
			scrollTopButton.click(function (event) {
				event.preventDefault();
				const container = $(event.target).closest('.js-switcher-content-item');
				if (breakpoint === 'mobile') {
					container.animate({
						scrollTop: 0
					}, 300);
				} else {
					$('html, body').animate({
						scrollTop: $('.faq__categories-wrapper').offset().top
					}, 300);
				}
			})
		}
	},
	cookieForCompanyPage() {

		$('.company-page').on(
			'click',
			function () {
				Cookies.set('page', 'company')
			}
		)
		$('.customer-page').on(
			'click',
			function () {
				Cookies.set('page', 'customer')
			}
		)
		if (Cookies.get('page') === 'company') {
			$('.company-page').addClass('active');
			$('.customer-page').removeClass('active');
			$('.header-nav__menu--company').addClass('active');
			$('.header-nav__menu--customer').removeClass('active');
		} else {
			$('.customer-page').addClass('active');
			$('.company-page').removeClass('active');
			$('.header-nav__menu--customer').addClass('active');
			$('.header-nav__menu--company').removeClass('active');
		}
	},
	showMore: () => {
		let submenuLists = document.querySelectorAll('.submenu__list'),
			sub_menu = document.querySelector('.header-nav__submenu.js-accordion');

		sub_menu?.addEventListener('mouseenter', function () {
			sub_menu.classList.remove('active')
		})

		submenuLists?.forEach(list => {
			hideExcessListItems(list);
			handleMoreButton(list);
		});

		function hideExcessListItems(list) {
			let listItems = list.querySelectorAll('.submenu__list-item');
			let moreButton = list.querySelector('.submenu__list-more');

			if (listItems && compensa_general.limit !== null) {
				for (let i = compensa_general.limit; i < listItems.length; i++) {
					listItems[i].style.display = 'none';
				}
			}


			if (listItems.length > compensa_general.limit) {
				if (moreButton) {
					moreButton.textContent = 'Więcej';
				} else {
					list.appendChild(showMoreButton());
				}
			}

			list.classList.add('submenu__list--shrinked');
		}

		function showExcessListItems(list) {
			let listItems = list.querySelectorAll('.submenu__list-item');
			for (let i = compensa_general.limit; i < listItems.length; i++) {
				listItems[i].style.display = 'list-item';
			}

			list.querySelector('.submenu__list-more').textContent = 'Mniej';
			list.classList.remove('submenu__list--shrinked');

			// Remove this line to bring back "Więcej -> Mniej" functionality
			//list.querySelector('.submenu__list-more').remove();
		}

		function showMoreButton() {
			let showMoreButton = document.createElement('span');
			showMoreButton.textContent = 'Więcej';
			showMoreButton.classList.add('arrow-link', 'arrow-link--green', 'submenu__list-more');
			return showMoreButton;
		}

		function handleMoreButton(list) {
			let moreButton = list.querySelector('.submenu__list-more');
			if (moreButton) {
				moreButton.addEventListener('click', function () {
					sub_menu.classList.add('active')
					if (list.classList.contains('submenu__list--shrinked')) {
						showExcessListItems(list);
					} else {
						hideExcessListItems(list);
					}
				});
			}
		}
	}
}
export default nav;
